export const comfortRoomDetails =
    [
        {
            roomType: "Comfort",
            title: "About the room",
            roomVideo: "/assets/comfortRoomVideo.mp4"
        }
    ]

export const comfortPlusRoomDetails =
    [
        {
            roomType: "Comfort Plus",
            title: "About the room",
            roomVideo: "/assets/comfortPlusRoomVideo.mp4"
        }
    ]

export const duplexRoomDetails =
    [
        {
            roomType: "Duplex",
            title: "About the room",
            roomVideo: "/assets/comfortPlusRoomVideo.mp4"
        }
    ]